import { number, oneOfType, shape, string } from 'prop-types'

export const multiAccountPropType = shape({
    displayUserName: string,
    externalIdentityId: oneOfType([number, string]),
    preferredUsername: string
})
